import React from "react";
import * as Sentry from "@sentry/react";
import { Route } from "react-router-dom";

import { ErrorBoundary } from "widgets/layouts";
import { LazyRemote } from "widgets/lazyremote";

import { BaseComponent, PrivateRoute } from "./components/base/index.jsx";
import { PortalTopNav } from "./portal/top.nav.jsx";
import { SupportChannel } from "./support_channel/index.jsx";

function PortalAppWrapper() {
  return (
    <ErrorBoundary>
      <BaseComponent baseName="/portal">
        <PrivateRoute path="/" baseRedirect={true}>
          <PortalHome />
        </PrivateRoute>
      </BaseComponent>
    </ErrorBoundary>
  );
}

export const PortalApp = Sentry.withProfiler(PortalAppWrapper);

function PortalHome() {
  return (
    <React.Fragment>
      <PortalTopNav />

      <Route path="/">
        <LazyRemote
          name="account"
          module="account/accounthome"
          componentName="PortalRuntime"
        />
        <SupportChannel />
      </Route>
    </React.Fragment>
  );
}
